
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class HarmonicWavesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const lines = Math.floor(15 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;

        const draw = () => {
            for (let i = 0; i < lines; i++) {
                ctx.beginPath();
                ctx.lineWidth = (2 / (layerIndex + 1)) * scale;
                const yBase = (height / lines) * i;
                
                for (let x = -width * 2; x <= width * 2; x += 10) {
                    const amplitude = (50 + i * 10) * scale;
                    const frequency = 0.005 + i * 0.001;
                    const y = yBase + Math.sin(x * frequency + curTime + i * 0.5) * amplitude;
                    if (x === -width * 2) ctx.moveTo(x, y);
                    else ctx.lineTo(x, y);
                }
                ctx.stroke();
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
